import React, { useContext, useState } from "react";
import { Dialog, Slide, Paper } from "@material-ui/core";
import axios from "axios";
import { isValidEmail } from "@tomocredit/common-fe/utils";
import { LEAD_SOURCES } from "@tomocredit/common-fe/consts";
import { BreakpointContext } from "components/common";
import closeIcon from "../../../images/x.svg";
import arrowRightIcon from "../../../images/arrow-right.svg";

const Transition = React.forwardRef((props, ref) => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModalContainer = (props) => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md"); // 768
  return (
    <Paper
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        height: belowMd ? 210 : 130,
        margin: 0,
        padding: 0,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};

/**
 *
 * @param {Object} props
 * @param {boolean} props.isVisible - The visibility of the drawer
 * @param {Function} props.onClose - The function to close the drawer
 * @param {Function} props.onChange - The function to handle the input change
 * @param {string} props.error - The error message to display
 * @param {Function} props.onSubmit - The function to proceed to checkout
 * @param {string} props.name - The name of the tier
 * @param {number} props.price - The price of the tier
 * @returns
 */
const EmailInputDrawer = (props) => {
  const { isVisible, onClose, onSubmit, name, price } =
    props;

  const [formEmail, setFormEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [productEnrolled, setProductEnrolled] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleEmailInput = (e) => {
    const emailInput = (e.target?.value?.trim() || "").toLowerCase();
    setFormEmail(emailInput);
    setProductEnrolled(false);
    if (emailInput.length && !isValidEmail(emailInput)) {
      setEmailError("Please enter a valid email");
    } else {
      setEmailError("");
    }
  };

  const handleSubmit = async () => {
    if (loading) {
      return;
    }

    if (!formEmail || !isValidEmail(formEmail)) {
      setEmailError("Please enter a valid email");
      return;
    }
    setEmailError('');

    setLoading(true);
    let signUpBoostRes;
    try {
      const payload = { email: formEmail, source: LEAD_SOURCES.BOOST_PRICING };
      signUpBoostRes = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/boost/signup`,
        payload,
      );
    } catch (err) {
      setEmailError("Could not communicate with server. Please try again later");
      return;
    } finally {
      setLoading(false);
    }

    const { boostEnrolled } = signUpBoostRes?.data ?? {};
    if (boostEnrolled) {
      setEmailError("You are already enrolled.");
      setProductEnrolled(true);
      return;
    }
    onSubmit(formEmail);
  };

  return (
    <Dialog
      open={isVisible}
      TransitionComponent={Transition}
      transitionDuration={1000}
      keepMounted
      onClose={onClose}
      PaperComponent={ModalContainer}
      fullWidth
      fullScreen
    >
      <div
        className="relative w-full h-full p-6 pb-9 md:pb-6 flex items-center justify-center"
        style={{ backgroundColor: "#4B4B4B" }}
      >
        <button
          type="button"
          className="absolute flex justify-center items-center"
          onClick={onClose}
          style={{
            height: 32,
            width: 32,
            top: 24,
            right: 24,
          }}
        >
          <img src={closeIcon} alt="close" />
        </button>
        <div className="flex flex-col md:flex-row md:items-center">
          <div className="flex flex-col">
            <span className="text-white text-2xl font-bold">
              Go to checkout
            </span>
            <span style={{ color: "#87DDA4" }} className="font-bold mt-1.5">
              {name} ${price.toFixed(2)}/mo
            </span>
          </div>
          <div className="flex flex-col md:ml-10 mt-4 md:mt-0">
            <span className="font-bold text-white text-xs">
              Payment options include credit card, Link, Cash App, Apple Pay,
              Google Pay.
            </span>
            <div className="flex mt-2">
              <input
                style={{
                  height: 40,
                  backgroundColor: "#FFFFFF",
                  borderTopLeftRadius: 6,
                  borderBottomLeftRadius: 6,
                  paddingLeft: 15,
                  color: "#5F5F5F",
                }}
                className="w-full"
                placeholder="Enter your email"
                onChange={handleEmailInput}
                onSubmit={handleSubmit}
              />
              <button
                type="button"
                style={{
                  padding: "8px 22px 8px 22px",
                  backgroundColor: "#7249F5",
                  borderTopRightRadius: 6,
                  borderBottomRightRadius: 6,
                  height: 40,
                  minWidth: 67,
                }}
                onClick={handleSubmit}
              >
                <img src={arrowRightIcon} alt="Go to checkout" />
              </button>
            </div>
            <div style={{ color: "#FFA9A9" }} className="flex">
              <p>{emailError}</p>
              {productEnrolled && (
                <div className="flex whitespace-pre flex-wrap">
                  <span> Click </span>
                  <a
                    href={`${process.env.REACT_APP_DOMAIN}/dashboard/login?redirect_uri=/boost&fromBoost=true`}
                    onClick={(e) => e.currentTarget.focus()}
                    className="same-host-redirect"
                  >
                    <p
                      className="hover:underline text-white"
                    >
                    here
                    </p>
                  </a>
                  <span> to log in.</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
export default EmailInputDrawer;
